import React from 'react';
import { 
    Box, 
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle 
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber'; 

export default function SubscriptionModal({ open, onRetry, onPricing, onClose }) {
    console.log('[SubscriptionModal] Rendering with props:', { open, hasOnClose: !!onClose });
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        elevation: 24,
        sx: {
          borderRadius: '16px', 
          p: 0,
          maxWidth: 400, // Similar to max-w-sm
        },
      }}
    >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, p: 3 }}>
            {/* Icon Wrapper */}
            <Box sx={{
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 40,
                width: 40,
                mt: 0.5,
                borderRadius: '50%',
                bgcolor: '#FEEFC3' 
            }}>
                <WarningAmberIcon sx={{ color: '#EA8600' }} />
            </Box>

            {/* Text Content */}
            <Box>
                <DialogTitle sx={{ fontWeight: 500, p: 0, fontSize: '1.25rem', color: '#202124' }}>
                    Subscription Issue
                </DialogTitle>
                <DialogContent sx={{ p: 0, mt: 0.5 }}>
                    <DialogContentText sx={{ fontSize: '0.875rem', color: '#5f6368' }}>
                        We couldn't verify your active subscription. This may be a temporary issue. Please try again, or visit our pricing page for other options.
                    </DialogContentText>
                </DialogContent>
            </Box>
        </Box>
      
      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <Button
          onClick={onRetry}
          variant="outlined"
          sx={{
            borderRadius: 9999, // Creates the pill shape
            textTransform: "none",
            fontWeight: 500,
            borderColor: 'grey.300',
            color: '#4285F4',
            px: 3,
            '&:hover': {
                bgcolor: 'rgba(66, 133, 244, 0.08)' // Light blue hover
            }
          }}
        >
          Try again
        </Button>
        <Button
          onClick={onPricing}
          variant="contained"
          sx={{
            borderRadius: 9999, // Creates the pill shape
            textTransform: "none",
            fontWeight: 500,
            bgcolor: "#4285F4",
            px: 3,
            boxShadow: 'none',
            ":hover": { 
                bgcolor: "#357ae8", // Darker blue on hover
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)'
            },
          }}
        >
          Go to pricing
        </Button>
      </DialogActions>
    </Dialog>
  );
}
